'use client';

import { ReactNode, createContext, useContext, useEffect } from 'react';

import { useCookies } from '@personly/libs-providers';

const QuoraContext = createContext(null);

interface Props {
  children?: ReactNode;
}

const QuoraProvider = ({ children }: Props) => {
  const { consent } = useCookies();

  useEffect(() => {
    if (process.env.NODE_ENV === 'development') return;

    if (!consent.types.includes('TARGETING')) return;

    setTimeout(() => {
      (function (q, e, v, n, t, s) {
        // @ts-ignore
        if (q.qp) return;
        // @ts-ignore
        n = q.qp = function () {
          n.qp ? n.qp.apply(n, arguments) : n.queue.push(arguments);
        };
        n.queue = [];
        t = document.createElement(e);
        t.async = !0;
        t.src = v;
        s = document.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, 'script', 'https://a.quora.com/qevents.js');
      // @ts-ignore
      window['qp']('init', '98b7ffb5cdc94592a07c6d35472822ea');
      // @ts-ignore
      window['qp']('track', 'ViewContent');
    }, 3000);
  }, [consent]);

  return children;
};

function useQuora() {
  const context = useContext(QuoraContext);
  if (!context) throw new Error('useQuora requires a context!');

  return context;
}

export { QuoraProvider, useQuora };
